
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '../../components/headerImage/index.vue'
import LazyImg from '../../components/lazyImg/index.vue'
import type { UserContent } from '@xt/client/entities/content/types.d'

const randomColors = ['#CBC3C6', '#C5CAC7', '#B8B6A2']

@Observer
@Component({
  components: {
    HeaderImage,
    LazyImg
  }
})
export default class UserContentCard extends Vue {
  @Prop({ required: true }) data: UserContent

  // 对于没有图片的内容，展示一个随机色块
  randomBgColor: string = ''

  compactImageSize(originWidth, originHeight) {
    const limitWidth = 180
    const shouldHeigth = Math.floor((limitWidth * originHeight) / originWidth)

    return [limitWidth, shouldHeigth]
  }

  getImageHeight(originWidth, originHeight) {
    return Math.max(100, Math.min(248, this.compactImageSize(originWidth, originHeight)[1]))
  }

  getImageURL(url, originWidth, originHeight) {
    const limitWidth = 180
    const limitHeight = 248
    const minHeight = 100
    const [, shouldHeigth] = this.compactImageSize(originWidth, originHeight)

    if (shouldHeigth > limitHeight) {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(limitHeight * 2), true)
    } else if (100 < shouldHeigth && shouldHeigth <= limitHeight) {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(shouldHeigth * 2))
      // 兼容过宽图片，缩放至可视窗口的问题
    } else {
      return this.ossProcessImg(url, Math.floor(limitWidth * 2), Math.floor(minHeight * 2), true)
    }
  }

  handleClickLike() {
    if (this.data.like === true) {
      this.$message.error('您已经点过赞了')
      return
    }

    this.$emit('click-like', { id: this.data.id })
  }

  created() {
    this.randomBgColor = randomColors[Math.floor(Math.random() * randomColors.length)]
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
